import { useEffect, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router"
import { OpenCellScheduleRow } from "@/pages/Settings/OpenCellSchedules/types"
import { schedulesFromAlarmSchedules } from "@/pages/Settings/OpenCellSchedules/utils"
import { AppDispatch, RootState } from "@/store"
import { fetchLevelAlarmSchedules } from "@/store/alarmSchedulesSlice"
import { getLevelPathName } from "@/utils/facilities"

export const useCellOpenCellSchedules = () => {
   const dispatch = useDispatch<AppDispatch>()
   const { id } = useParams<{ id: string }>()
   const levels = useSelector(
      ({ facilitiesReducer }: RootState) =>
         facilitiesReducer.facilityDetails.levels
   )
   const {
      levelAlarmSchedules,
      loadingLevelAlarmSchedules: isLoading,
      errorLevelAlarmSchedules: error,
   } = useSelector(
      ({ alarmSchedulesReducer }: RootState) => alarmSchedulesReducer
   )

   // First parent only: the backend doesn't cover cells with several parents yet (GC-1989).
   const parentId = levels?.find((level) => level.id === id)?.parents[0]

   useEffect(() => {
      if (!parentId) return
      dispatch(fetchLevelAlarmSchedules(parentId))
   }, [dispatch, parentId])

   const schedules = useMemo(() => {
      if (!levels) return []

      return schedulesFromAlarmSchedules(levelAlarmSchedules).map(
         (schedule): OpenCellScheduleRow => ({
            ...schedule,
            levelName: getLevelPathName(levels, schedule.levelId),
            levelIcon: levels.find((level) => level.id === schedule.levelId)
               ?.type.icon as OpenCellScheduleRow["levelIcon"],
         })
      )
   }, [levelAlarmSchedules, levels])

   return { schedules, isLoading, error }
}
